/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeClockViewKey {
  static readonly SHELL = 'time-clock/view/shell';
  static readonly IDLE = 'time-clock/view/idle';
  static readonly REGISTER = 'time-clock/view/register';
  static readonly EMPLOYEE = 'time-clock/view/employee';
}
